(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.searchModal = this.querySelector('details-modal');
      this.isSearchActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // Listen for search modal open/close events
      if (this.searchModal) {
        this.searchModal.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.isSearchActive = false;
        });

        this.searchModal.querySelector('details').addEventListener('toggle', (event) => {
          this.isSearchActive = event.target.hasAttribute('open');
        });
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.isSearchActive) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.isSearchActive) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if (this.isSearchActive) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        const details = this.searchModal.querySelector('details');
        if (details && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight"] && !Shopify.designMode) return;
  try {
    
  class ProductSpotlightSlider {
    constructor(element) {
      this.slider = element;
      this.track = this.slider.querySelector('[data-spotlight-track]');
      this.prevButton = this.slider.querySelector('[data-spotlight-prev]');
      this.nextButton = this.slider.querySelector('[data-spotlight-next]');
      this.currentIndex = 0;
      this.totalSlides = this.track.children.length;

      this.#init();
    }

    #init() {
      if (this.totalSlides <= 1) {
        if (this.prevButton) this.prevButton.style.display = 'none';
        if (this.nextButton) this.nextButton.style.display = 'none';
        this.#dispatchSlideChange();
        return;
      }

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.#goToPrev());
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.#goToNext());
      this.#updateButtons();
      this.#dispatchSlideChange();
    }

    #goToNext() {
      if (this.currentIndex < this.totalSlides - 1) {
        this.currentIndex++;
        this.#updateSlidePosition();
        this.#updateButtons();
        this.#dispatchSlideChange();
      }
    }

    #goToPrev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.#updateSlidePosition();
        this.#updateButtons();
        this.#dispatchSlideChange();
      }
    }

    #dispatchSlideChange() {
      const currentItem = this.track.children[this.currentIndex];
      const subtitle = currentItem.dataset.subtitle;
      const showAbove = this.slider.dataset.showSubtitleAbove === 'true';

      if (showAbove) {
        document.dispatchEvent(new CustomEvent('spotlight:slideChange', {
          detail: { subtitle }
        }));
      }
    }

    #updateSlidePosition() {
      const offset = -this.currentIndex * 100;
      this.track.style.transform = `translateX(${offset}%)`;
    }

    #updateButtons() {
      if (this.prevButton) this.prevButton.disabled = this.currentIndex === 0;
      if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.totalSlides - 1;
    }
  }

  const initProductSpotlightSlider = () => {
    const sliderElement = document.querySelector('[data-product-spotlight-slider]');
    if (sliderElement) {
      new ProductSpotlightSlider(sliderElement);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSpotlightSlider);
  } else {
    initProductSpotlightSlider();
  }

  } catch(e) { console.error(e); }
})();
})();
